import ApiClient from "../helpers/ApiClient";

const baseEmpresaEndpoint = (cnpj) => `/empresa/${cnpj}`;

const getDadosNota = (cnpj, params) =>
  ApiClient.apiClientDef.get(`${baseEmpresaEndpoint(cnpj)}/getLastNota`, {
    params,
  });

const emitirNota = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `${baseEmpresaEndpoint(cnpj)}/notas_fiscais/emitir/`,
    data
  );

const getNotasFiscais = (cnpj, params) =>
  ApiClient.apiClientDef.get(`/empresa/${cnpj}/notas_fiscais`, { params });

const postNotasFiscais = (cnpj, data) =>
  ApiClient.apiClientDef.post(`/empresa/${cnpj}/notas_fiscais`, data);

const getNotaFiscal = (cnpj, uid, params) =>
  ApiClient.apiClientDef.get(`/empresa/${cnpj}/notas_fiscais/${uid}`, {
    params,
    responseType: "arraybuffer",
  });

const deleteNotaFiscal = (cnpj, uid) =>
  ApiClient.apiClientDef.delete(`/empresa/${cnpj}/notas_fiscais/${uid}`);

const solicitarCancelamento = (cnpj, uid, data) =>
  ApiClient.apiClientDef.put(`/empresa/${cnpj}/notas_fiscais/${uid}`, data);

const enviarEmails = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `/empresa/${cnpj}/notas_fiscais/enviar_email/`,
    data
  );

const downloadEmMassa = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `/empresa/${cnpj}/notas_fiscais/download_massa/`,
    data,
    { responseType: "arraybuffer" }
  );

const cancelarNota = (cnpj, data, uid) =>
  ApiClient.apiClientDef.delete(
    `/empresa/${cnpj}/notas_fiscais/cancelar/${uid}`,
    { data }
  );

const getBloqueio = (cnpj) =>
  ApiClient.apiClientDef.get(`/empresa/${cnpj}/verificar_emissor`);

const getCodigosMunicipio = (cnpj, params) =>
  ApiClient.apiClientDef.get(`/empresa/${cnpj}/codigos_municipio`, { params });

const atualizarNotaFiscal = (cnpj, uid) =>
  ApiClient.apiClientDef.post(`/empresa/${cnpj}/notas_fiscais/${uid}`, null);

const cancelarNotaPrefeitura = (cnpj, uid) =>
  ApiClient.apiClientDef.post(`/empresa/${cnpj}/notas_fiscais/cancelar/${uid}`);

const emailEmMassa = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `/empresa/${cnpj}/notas_fiscais/email_massa/`,
    data
  );

const sincronizarNotas = (cnpj, data) =>
  ApiClient.apiClientDef.post(`/empresa/${cnpj}/sinc/zen`, data);

const NotaFiscalApiClient = {
  getNotasFiscais,
  postNotasFiscais,
  getNotaFiscal,
  deleteNotaFiscal,
  solicitarCancelamento,
  enviarEmails,
  downloadEmMassa,
  cancelarNota,
  getDadosNota,
  emitirNota,
  getBloqueio,
  getCodigosMunicipio,
  atualizarNotaFiscal,
  cancelarNotaPrefeitura,
  emailEmMassa,
  sincronizarNotas,
};
export default NotaFiscalApiClient;
